import React, {useEffect, useState} from "react";
import ProfileForm from "./ProfileForm"; // Angenommen, dies ist Ihre Komponente für das Aufgabenprofil
import ContractForm from "./ContractForm"; // Ihre ContractDataForm-Komponente
import EmploymentForm from "./EmploymentForm";
import FormSummary from "../component/FormSummary";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {getContractRequest} from "../redux/actions/contractActions";
import {RESET_CONTRACTS_LOADED} from "../redux/constants/contractActionTypes";
import {getEmployeeRequest} from "../redux/actions/employeeActions";

const EmploymentFormContainer = () => {
    const { id} = useParams();
    const dispatch = useDispatch();
    const contract = useSelector(state => state.contract.contract);
    const contractsLoaded = useSelector(state => state.contract.contractsLoaded);
    const isLoadingContract = useSelector(state => state.contract.loading.getContract);
    const employee = useSelector(state => state.employee.employee);
    const isLoadingEmployee = useSelector(state => state.employee.loading.getEmployee);
    const [currentStep, setCurrentStep] = useState(1);

    useEffect(() => {
        if (contractsLoaded) {
            dispatch({type: RESET_CONTRACTS_LOADED});
        }
        if (!('ID' in contract) && contract.ID !== id && !isLoadingContract) {
            dispatch(getContractRequest({ contractID: id }));
        }
    }, [dispatch, contract, id, isLoadingContract, contractsLoaded]);

    useEffect(() => {
        if (!('ID' in employee) && !isLoadingEmployee) {
            dispatch(getEmployeeRequest({ contractID : id }));
        }
    }, [dispatch, employee, isLoadingEmployee, id]);

    const goToPreviousStep = () => setCurrentStep(currentStep - 1);
    const goToNextStep = () => setCurrentStep(currentStep + 1);
    const renderStep = () => {
        let submitButtonText = "Weiter";

        if (currentStep === 4) {
            submitButtonText = "Speichern";
        }
        switch (currentStep) {
            case 1:
                return <EmploymentForm
                    contract={contract}
                    setCurrentStep={goToNextStep}
                    previousStep=""
                    submitButtonText={submitButtonText}
                />;
            case 2:
                return <ProfileForm
                    contract={contract}
                    employee={employee}
                    setCurrentStep={goToNextStep}
                    previousStep={goToPreviousStep}
                    submitButtonText={submitButtonText}
                />;
            case 3:
                return <ContractForm
                    contract={contract}
                    setCurrentStep={goToNextStep}
                    previousStep={goToPreviousStep}
                    submitButtonText={submitButtonText}
                />;
            case 4:
                return <FormSummary
                    contract={contract}
                    setCurrentStep={goToNextStep}
                    previousStep={goToPreviousStep}
                    submitButtonText={submitButtonText}
                />;
            default:
                return <div>Unbekannter Schritt</div>;
        }
    };

    return (
        <div className="container mt-5">
            <div className="mb-3">
                <div className="row">
                    <div className="col-12" style={{textAlign: "center", marginBottom: "3.5vh"}}>
                        <h2>Mitverwendungsantrag</h2>
                    </div>
                </div>
                {renderStep()}
            </div>
        </div>
    );

};

export default EmploymentFormContainer;

